/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPortfoliosPerformance} from '../api'

 export const useQueryGetPortfoliosPerformance = createReactQueryHook('getPortfoliosPerformance', getPortfoliosPerformance)
